<template>
<div class="animated fadeIn mt-3 dashboard">
  <b-card no-body class="objective-cards" v-if="$auth.check(['dashboard.objectives'])">
    <b-card-header>
      Objectivos Sellout
      <span class="float-right form-inline">
        <b-form-select :disabled="loading" v-model="selectedYear" :options="years" class="mr-2" size="sm" />
        <b-form-select :disabled="loading" v-model="selectedMonthStart" :options="monthOptions" class="" size="sm" /> a <b-form-select :disabled="loading" v-model="selectedMonthEnd" :options="monthOptions" class="" size="sm" /></span>
    </b-card-header>
    <b-card-body>
    <b-row>
      <b-col sm="12" lg="4" xl="4">
        <objectives-table :loading="loading" :items="scorecard.sellout" :per-page="0" :fields="npsFields" :show-remaining="false" table-caption="NPS Categoria" symbol="€"></objectives-table>
      </b-col>
      <b-col sm="12" lg="4" xl="4">
        <objectives-table :loading="loading" :items="scorecard.operators" :per-page="0" :fields="operatorsFields" :show-remaining="false" table-caption="Operadores Categoria" symbol=""></objectives-table>
      </b-col>
      <b-col sm="12" lg="4" xl="4">
        <objectives-table :loading="loading" :items="scorecard.sumtop10" :per-page="0" :fields="operatorsFields" :show-remaining="false" table-caption="SumTop10 Categoria" symbol=""></objectives-table>
      </b-col>
    </b-row>
    </b-card-body>
  </b-card>
  <b-card no-body class="objective-cards" v-if="$auth.check(['dashboard.objectives'])">
    <b-card-header>
      Performance
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col sm="12" lg="4" xl="4">
          <objectives-table :loading="loading" :items="scorecard.dealers.ufs" :per-page="0" :fields="dealerFields" :show-remaining="false" table-caption="DESEMPENHO POR DISTRIBUIDOR UFS - NPS " symbol="€"></objectives-table>
        </b-col>
        <b-col sm="12" lg="4" xl="4">
          <objectives-table :loading="loading" :items="scorecard.dealers.spreads" :per-page="0" :fields="dealerFields" :show-remaining="false" table-caption="DESEMPENHO POR DISTRIBUIDOR UPFIELD - NPS " symbol="€"></objectives-table>
        </b-col>
        <b-col sm="12" lg="4" xl="4">
          <objectives-table :loading="loading" :items="scorecard.dealers_operators" :per-page="0" :fields="dealerOperatorsFields" :show-remaining="false" table-caption="DESEMPENHO POR DISTRIBUIDOR UFS + UPFIELD - OPERADORES " symbol=""></objectives-table>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
  <b-card no-body class="objective-cards" v-if="$auth.check(['dashboard.objectives'])">
    <b-card-header>
      Sellin
    </b-card-header>
    <b-card-body>

    <b-row>
      <b-col sm="12" lg="4" xl="4">
        <objectives-table :loading="loading" :items="scorecard.sellin.niv" :per-page="0" :fields="npsFields" :show-remaining="false" table-caption="NIV CATEGORIA" symbol="€"></objectives-table>
      </b-col>
      <b-col sm="12" lg="4" xl="4">
        <objectives-table :loading="loading" :items="scorecard.sellin.turnover" :per-page="0" :fields="npsFields" :show-remaining="false" table-caption="TO CATEGORIA" symbol="€"></objectives-table>
      </b-col>
      <b-col sm="12" lg="4" xl="4">
        <objectives-table :loading="loading" :items="scorecard.sellin.top10" :per-page="0" :fields="npsFields" :show-remaining="false" table-caption="TOP10 NIV" symbol="€"></objectives-table>
      </b-col>
    </b-row>
    </b-card-body>
  </b-card>
</div>
</template>

<script>
import ObjectivesTable from './dashboard/ObjectivesTable'
import EffectivenessTable from './dashboard/EffectivenessTable'
export default {
  name: 'dashboard',
  components: {
    ObjectivesTable,
    EffectivenessTable
  },
  data: function() {
    return {
      lastUpdate: [],
      loading: false,
      scorecard: {
        sellout: [],
        selloutTop10: [],
        operators: [],
        sumtop10: [],
        dealers_operators: [],
        dealers: {
          ufs: [],
          spreads: []
        },
        sellin: {
          niv: [],
          turnover: [],
          top10: []
        }
      },
      objectivesPeriods: [{
        value: 1,
        text: 'mês'
      }, {
        value: 2,
        text: 'acumulado até'
      }],
      years: [{
        value: 2026,
        text: '2026'
      }, {
        value: 2025,
        text: '2025'
      }],
      selectedMonth: null,
      zone: null,
      selectedPeriod: 1,
      selectedYear: null,
      selectedMonthEnd: null,
      selectedMonthStart: null,
      selectedMonthLitersLE: null,
      effectiveness: [],
      litersLE: [],
      accounts: {
        open_docs: 0,
        expired_docs: 0,
        avg_expired_docs: 0,
        days_behind: 0,
        open_value: 0,
        expired_value: 0
      },
      monthOptions: [],
      objectivesZones: [],
      effectivenessCurrentPage: 1,
      npsFields: [
        { key: 'label', label: 'Categoria', sortable: true },
        { key: 'objective', label: 'Objectivo', sortable: true },
        { key: 'total', label: 'Real', sortable: true },
        { key: 'progress', label: 'Progresso', sortable: true }
      ],
      operatorsFields: [
        { key: 'label', label: 'Categoria', sortable: true },
        { key: 'objective', label: 'Homólogo', sortable: true },
        { key: 'total', label: 'Real', sortable: true },
        { key: 'progress', label: 'Progresso', sortable: true }
      ],
      dealerOperatorsFields: [
        { key: 'label', label: 'Categoria', sortable: true },
        { key: 'objective', label: 'Homólogo', sortable: true },
        { key: 'total', label: 'Real', sortable: true },
        { key: 'progress', label: 'Progresso', sortable: true }
      ],
      dealerFields: [
        { key: 'label', label: 'Distribuidor', sortable: true },
        { key: 'objective', label: 'Objectivo', sortable: true },
        { key: 'total', label: 'Real', sortable: true },
        { key: 'progress', label: 'Progresso', sortable: true }
      ],
      objective_items: [
        'sellout',
        'sumtop10',
        'operators',
        'dealers/0',
        'dealers/1',
        'sellin',
        'dealers_operators'
      ]
    }
  },
  watch: {
    selectedYear: {
      handler: function(newValue) {
        this.loadObjectives(this.selectedMonthStart, this.selectedMonthEnd)
      }
    },
    selectedMonthStart: {
      handler: function(newValue) {
        var p = this.selectedMonthEnd
        if (newValue.month > p.month) {
          this.selectedMonthEnd = newValue
          p = this.selectedMonthEnd
        }
        console.log('selectedMonthStart', newValue)
        console.log('selectedMonthEnd', p)
        this.loadObjectives(newValue, p)
      }
    },
    selectedMonthEnd: {
      handler: function(newValue) {
        var p = this.selectedMonthStart
        if (newValue.month < p.month) {
          this.selectedMonthStart = newValue
          p = this.selectedMonthStart
        }
        console.log('selectedMonthEnd', newValue)
        console.log('selectedMonthStart', p)
        this.loadObjectives(p, newValue)
      }
    }
  },
  methods: {
    loadObjectives(start, end) {
      if (!this.loading) {
        this.loading = true
        var data = {
          analysisType: this.selectedPeriod,
          year: this.selectedYear,
          start: start,
          end: end
        }
        let requests = []
        for (let i = 0; i < this.objective_items.length; i++) {
          requests.push(this.axios.post('dashboard/' + this.objective_items[i], data))
        }

        this.axios.all(requests).then(this.axios.spread((...responses) => {
          for (let i = 0; i < this.objective_items.length; i++) {
            if (this.objective_items[i] === 'dealers/0') {
              this.scorecard.dealers.ufs = responses[i].data.data
            } else if (this.objective_items[i] === 'dealers/1') {
              this.scorecard.dealers.spreads = responses[i].data.data
            } else {
              this.scorecard[this.objective_items[i]] = responses[i].data.data
            }
            this.loading = false
          }
          // use/access the results
        })).catch(errors => {
          // react on errors.
          this.loading = false
        })
      }
    }
  },
  created() {
    // this.axios.post('dashboard/sellout', this.).then(response => {

    // })
    let d = new Date()
    let m = d.getMonth()
    this.axios.get('dashboard/objectives').then(response => {
      this.monthOptions = response.data.data.months
      this.selectedMonthStart = this.monthOptions[m].value
      this.selectedMonthEnd = this.monthOptions[m].value
      this.selectedYear = this.years[0].value
    })
  }
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?0f703f58